import allowedOptionsApi from "../../api/settings/allowedOptionsApi";
import { AllowedOptionDTO, AllowedOptionListDTO } from "../../types/settings/allowedOptionsInterfaces";

/**
 * Servicio para interactuar con la API de opciones permitidas (AllowedOptions).
 */
const AllowedOptionsService = {
    // 🔹 Obtener TODAS las opciones agrupadas por módulo y target
    fetchGroupedOptions: async () => {
        const response = await allowedOptionsApi.fetchCustom("/grouped");
        return response.data;
    },

    // 🔹 Actualizar múltiples opciones en lote
    updateOptionList: async (payload: AllowedOptionListDTO) => {
        const response = await allowedOptionsApi.modifyCustom("/batch", payload);
        return response.data;
    },

    // 🔹 Actualizar una sola opción
    updateSingleOption: async (option: AllowedOptionDTO) => {
        const response = await allowedOptionsApi.modifyCustom("/single", option);
        return response.data;

    },

    // 🔹 Obtener solo los códigos permitidos por módulo y target
    fetchAllowedCodes: async (module: string, target: string) => {
        const response = await allowedOptionsApi.fetchCustom(`/codes?module=${module}&target=${target}`);
        return response.data;
    },
};

export default AllowedOptionsService;
